import { Box, Typography, Grid, Select, Option } from "@mui/joy";
import { Wind, Paintbrush, Gauge, Hash } from "lucide-react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { FormInput, FormSelect, FormActionSelect } from "../../../shared";
import React from "react";

export function Ventilation({ loading }: { loading?: boolean }) {
    const { control } = useFormContext();

    const ventilationType = useWatch({ name: "VentilationType", control });

    return (
        <Box
        >
            <Box mb={2}>
                <Typography level="title-md">Ventilation</Typography>
                <Typography level="body-sm" color="neutral">
                    Specify ventilation types and counts for the roof system.
                </Typography>
            </Box>

            <Box
                sx={{
                    p: 2,
                    borderRadius: "4px",
                    border: "1px solid",
                    borderColor: "rgba(128, 128, 128, 0.2)",
                    bgcolor: "rgba(128, 128, 128, 0.05)",
                    backdropFilter: "blur(12px)",
                }}
            >
                <Grid container spacing={2.5}>
                    <Grid xs={12} sm={12} md={6} lg={6}>
                        <FormSelect
                            name="VentilationType"
                            label="Ventilation Type"
                            placeholder="Select type"
                            helperText="Primary roof ventilation."
                            disabled={loading}
                            startDecorator={<Wind size={16} />}
                            options={[
                                "Ridge Vent",
                                "Roof Vent",
                                "Gable Vent",
                                "None",
                            ]}
                        />
                    </Grid>

                    <Grid xs={12} sm={12} md={6} lg={6}>
                        <FormSelect
                            name="VentilationPainted"
                            label="Painted"
                            placeholder="Select option"
                            helperText="Is the ventilation painted?"
                            disabled={loading}
                            startDecorator={<Paintbrush size={16} />}
                            options={["Yes", "No"]}
                        />
                    </Grid>

                    <Grid xs={12}>
                        <Grid container spacing={2.5}>
                            <Grid xs={12} sm={12} md={6} lg={6}>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                                    <Typography level="body-xs" sx={{ textTransform: "uppercase", fontWeight: "xl", letterSpacing: "0.5px" }}>
                                        Box Vent Count
                                    </Typography>
                                    <Typography level="body-xs" color="neutral" sx={{ mt: -0.5, mb: 0.5, fontSize: "12px" }}>
                                        Number of box vents and action.
                                    </Typography>
                                    <Box sx={{ display: "flex", gap: 0, alignItems: "flex-start" }}>
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                            <FormInput
                                                name="BoxVentQty"
                                                type="number"
                                                placeholder="0"
                                                sx={{
                                                    borderTopRightRadius: 0,
                                                    borderBottomRightRadius: 0,
                                                    borderRight: 0,
                                                    minWidth: 0,
                                                }}
                                                disabled={loading || ventilationType !== "Roof Vent"}
                                                startDecorator={<Hash size={16} />}
                                            />
                                        </Box>
                                        <Box sx={{ width: 100, flexShrink: 0 }}>
                                            <FormActionSelect
                                                name="BoxVentAction"
                                                disabled={loading || ventilationType !== "Roof Vent"}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid xs={12} sm={12} md={6} lg={6}>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                                    <Typography level="body-xs" sx={{ textTransform: "uppercase", fontWeight: "xl", letterSpacing: "0.5px" }}>
                                        Turbine Vent Count
                                    </Typography>
                                    <Typography level="body-xs" color="neutral" sx={{ mt: -0.5, mb: 0.5, fontSize: "12px" }}>
                                        Number of turbine vents and action.
                                    </Typography>
                                    <Box sx={{ display: "flex", gap: 0, alignItems: "flex-start" }}>
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                            <FormInput
                                                name="TurbineVentQty"
                                                type="number"
                                                placeholder="0"
                                                sx={{
                                                    borderTopRightRadius: 0,
                                                    borderBottomRightRadius: 0,
                                                    borderRight: 0,
                                                    minWidth: 0,
                                                }}
                                                disabled={loading || ventilationType !== "Roof Vent"}
                                                startDecorator={<Hash size={16} />}
                                            />
                                        </Box>
                                        <Box sx={{ width: 100, flexShrink: 0 }}>
                                            <FormActionSelect
                                                name="TurbineVentAction"
                                                disabled={loading || ventilationType !== "Roof Vent"}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
